module.exports = new __parcel__URL__("fleche-vent.119f7036.svg").toString();